module.exports = __webpack_public_path__ + "img/confluence.341d9c53.png";